import { Suspense, type ReactNode } from "react";
import { TaskNudges } from "./TaskNudges";
import { useRoleRefresh } from "./useRoleRefresh";
import { logClientError, useErrorLog } from "./useErrorLog";
import { ViewAsBanner } from "./ViewAs";
import { ErrorBoundary } from "react-error-boundary";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { AppSidebar } from "./Sidebar";

export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  useRoleRefresh();
  useErrorLog();
  return (
    <DataImportProvider>
      <SidebarProvider>
        <AppSidebar />
        {/* min-w-0: wide content (the funnel board) scrolls instead of widening the page */}
        <SidebarInset className="min-w-0">
          {/* SidebarInset already renders <main> */}
          <ViewAsBanner />
          <div className="w-full p-4 md:p-6 2xl:px-8" id="main-content">
            <ErrorBoundary
              FallbackComponent={Error}
              onError={(error) =>
                logClientError(String((error as Error)?.message ?? error), {
                  stack: (error as Error)?.stack?.slice(0, 1500),
                  boundary: true,
                })
              }
            >
              <Suspense
                fallback={<Skeleton className="h-12 w-12 rounded-full" />}
              >
                {children}
              </Suspense>
            </ErrorBoundary>
          </div>
        </SidebarInset>
      </SidebarProvider>
      <Notification />
      <TaskNudges />
    </DataImportProvider>
  );
};
